<template>
  <RsPartialNavigationContainer v-if="isToursVisible" :key="variant">
    <RsPartialNavigationTree
      :title="$ts('tours.list.nav.tours')"
      icon="far fa-calendar-day rs-text-tertiary-medium-purple"
      active-icon="fas fa-calendar-day rs-text-primary"
      icon-size="lg"
      :variant="variant"
      :expanded="expanded"
      :active="routeStartsWith('/tours')"
    >
      <RsPartialNavigationTreeBranch
        :title="$ts('tours.list.nav.toursList')"
        :to="{ name: 'Tours' }"
        :active="routeEndsWith('/tours')"
      />
      <RsPartialNavigationTreeBranch
        :title="$ts('tours.list.nav.calendar')"
        :to="{ name: 'Calendar' }"
        :active="routeEndsWith('/tours/calendar')"
      />
      <RsPartialNavigationTreeBranch v-if="isToursAdmin">
        <RsPartialNavigationTree
          :title="$ts('tours.list.nav.settings')"
          :expanded="routeStartsWith('/tours/settings/') || routeStartsWith('/tours/nylas/settings/')"
        >
          <RsPartialNavigationTreeBranch
            :title="$ts('tours.list.nav.generalSettings')"
            :to="{ name: 'General Settings' }"
            :active="routeEndsWith('/tours/settings/tour-general')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('tours.list.nav.formSettings')"
            :to="{ name: 'Form Settings' }"
            :active="routeEndsWith('/tours/settings/tour-forms')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('tours.list.nav.propertySettings')"
            :to="{ name: 'Property Settings' }"
            :active="routeStartsWith('/tours/settings/tour-properties')"
          />
          <RsPartialNavigationTreeBranch
            :title="$ts('tours.list.nav.agentSettings')"
            :to="tourAgentSettingsPath"
            :active="routeStartsWith('/tours/settings/agent-settings') || routeStartsWith('/tours/nylas/settings/agent-settings')"
          />
          <RsPartialNavigationTreeBranch v-if="$rsGlobals.$currentUser.isSuperUser">
            <RsPartialNavigationTree
              :title="$ts('tours.list.nav.superAdminSettings')"
              :expanded="routeStartsWith('/tours/settings/super-admin')"
            >
              <RsPartialNavigationTreeBranch
                :title="$ts('tours.list.nav.generalSettings')"
                :to="{ name: 'Super Admin General Settings' }"
                :active="routeStartsWith('/tours/settings/super-admin/general')"
              />
              <RsPartialNavigationTreeBranch
                :title="$ts('tours.list.nav.adEventTracking')"
                :to="{ name: 'Super Admin Ads' }"
                :active="routeStartsWith('/tours/settings/super-admin/google-ad-event-tracking')"
              />
            </RsPartialNavigationTree>
          </RsPartialNavigationTreeBranch>
        </RsPartialNavigationTree>
      </RsPartialNavigationTreeBranch>
      <RsPartialNavigationTreeBranch
        v-else
        :title="$ts('tours.list.nav.settings')"
        :to="tourAgentSettingsPath"
        :active="routeStartsWith('/tours/settings/agent-settings') || routeStartsWith('/tours/nylas/settings/agent-settings')"
      />
    </RsPartialNavigationTree>
  </RsPartialNavigationContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RsPartialNavigationContainer from '@/components/RsPartialNavigationContainer.vue';
import RsPartialNavigationTree from '@/components/RsPartialNavigationTree.vue';
import RsPartialNavigationTreeBranch from '@/components/RsPartialNavigationTreeBranch.vue';
import { routeEndsWith, routeParamExists, routeStartsWith } from '@/shared/helpers/navigation-active-helpers';

export default defineComponent({
  components: {
    RsPartialNavigationContainer,
    RsPartialNavigationTree,
    RsPartialNavigationTreeBranch,
  },

  props: {
    variant: {
      type: String,
      default: 'collapse',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isToursVisible(): boolean {
      return ['tour_admins', 'tour_agents'].some((p) => this.$rsGlobals.$currentUser.hasAtLeastOneModel(p));
    },

    isToursAdmin(): boolean {
      return ['tour_admins'].some((p) => this.$rsGlobals.$currentUser.hasAtLeastOneModel(p));
    },

    tourAgentSettingsPath(): string {
      return this.isToursAdmin
        ? `/tours/settings/agent-settings`
        : `/tours/settings/agent-settings/${this.$rsGlobals.$currentUser.userId}/agent`;
    },
  },

  methods: {
    routeStartsWith,
    routeEndsWith,
    routeParamExists,
  },
});
</script>
